// Pasaya
import useDecodeToken from "@/utils/hooks/useDecodeJwt";
import dataManagement from "@/navigation/data-management";
import inventory from "@/navigation/inventory";
import privileges from "@/navigation/privileges";
import report from "@/navigation/report";
import banner from "@/navigation/banner";
import tags from "@/navigation/tags";
import fulfillment from "@/navigation/fulfillment";
import document from "@/navigation/document";
import article from "@/navigation/article";
import survey from "@/navigation/survey";

const { decodeToken } = useDecodeToken();
const renderNavByPermission = () => {
  switch (decodeToken()?.provider_ref) {
    case "PVRtgXUzRdn1zB": // Prod Pasaya BO EP SA
      switch (decodeToken()?.sub) {
        case "ID_n5LTPdLLohXa": // prod peeranat.am@chococrm.com for test
        case "ID_QBruF6PMlrdm": // Prod ratiya.pasaya@gmail.com
        case "ID_ghlpmGF07lPy": // Prod Chutikan.pasaya@gmail.com
        case "ID_7DS8WGUEsJI2": // Prod asutorn.pasaya@gmail.com
        case "ID_9CwscvF3swCO": // Prod pornsudaklangsombat@gmail.com
        case "ID_BSSV0b4vdZm4": // Prod naritta@pasaya.com
        case "ID_d9CVMOPaizcO": // Prod akarin.pasaya@gmail.com
        case "ID_ktQ6Eg7j2GzV": // Prod It_helpdesk@pasaya.com
          return [
            ...dataManagement,
            ...banner,
            ...article,
            ...survey,
            ...privileges,
            ...fulfillment,
            ...inventory,
            ...document,
            ...tags,
            ...report,
          ];
      }

    case "PVuSe1wTohu2tG": // Pasaya BO EP AM
      switch (decodeToken()?.sub) {
        case "ID_sYBsJ5HXc2hr": // prod peeranat.am@chococrm.com for test
        case "ID_yiGsdwnIp8Qp": // prod account@pasaya.com
          return [...dataManagement, ...report];
      }

    case "PV6d9TTuJIM9Cg": // Paysaya BO EP CS
      switch (decodeToken()?.sub) {
        case "ID_OlQSArLbdGFg": //Prod peeranat.cs@chococrm.com for test
        case "ID_zVky6mRK1EaS": //Prod donnaphat.pasaya@gmail.com
        case "ID_y2KwbKa7KCOz": //Prod nonthacha.pasaya@gmail.com
        case "ID_QuV1eFCXWfOF": //Prod puntipar.pasaya@gmail.com
        case "ID_hzVQnrozawvk": //Prod boossakon@pasaya.com
        case "ID_Hq8UNfCKG7El": //Prod suppanut.pasaya@gmail.com
        case "ID_qAQCr14CAAe5": //Prod eshop.pasaya@gmail.com
        case "ID_m8WIhyFJVRtr": //Prod customercare@pasaya.com
        case "ID_mKOIFMU5hmB3": //Prod shop_paragon@pasaya.com
        case "ID_hDihVCs3XEbv": //Prod phuket_outlet@pasaya.com
        case "ID_7M6NBc5QCA0M": //Prod pattaya_outlet@pasaya.com
        case "ID_xZscK6QcbS6s": //Prod siampremiumoutlet@pasaya.com
        case "ID_SGkUPDK2UALF": //Prod pasayabiotech_medpark@pasaya.com
        case "ID_sEGQGjOeWjBS": //Prod outletsathorn@pasaya.com
        case "ID_HiWp85C8bmM3": //Prod outlet_wangmanao@pasaya.com
        case "ID_SjLtin1OuUMQ": //Prod outletthonglor@pasaya.com
        case "ID_gQ98uuHRU6Rx": //Prod chaam_outlet@pasaya.com
        case "ID_9OdfczAVKpIe": //Prod khaoyai_outlet@pasaya.com
        case "ID_JInhDZPAg4o1": //Prod central_village@pasaya.com
        case "ID_ExTL5hOYOPtD": //Prod factoryoutlet@pasaya.com
          return [...dataManagement];
      }
    default:
      return [
        ...dataManagement,
        ...banner,
        ...article,
        ...survey,
        ...privileges,
        ...fulfillment,
        ...inventory,
        ...document,
        ...tags,
        ...report,
      ];
  }
};

export default renderNavByPermission();
